import { render } from "./ImageMismatchModal.vue?vue&type=template&id=4d6069a4&scoped=true"
import script from "./ImageMismatchModal.vue?vue&type=script&lang=js"
export * from "./ImageMismatchModal.vue?vue&type=script&lang=js"

import "./ImageMismatchModal.vue?vue&type=style&index=0&id=4d6069a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6069a4"]])

export default __exports__